const postHelpRequestPayload = (payload) => {
  return { studioId: payload?.studioId, notes: payload?.notes };
};

export default postHelpRequestPayload;
